import api from './client';

export const bannerApi = {
  getSettings: () => api.get('/banner/settings'),
  getActive: () => api.get('/banner/active'),
  click: (adId) => api.post(`/banner/click/${adId}`),
  create: (data) => api.post('/banner/create', data),
  getMyBanners: () => api.get('/banner/my-banners'),
  update: (adId, data) => api.put(`/banner/update/${adId}`, data),
  delete: (adId) => api.delete(`/banner/${adId}`),
};
